import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import CheckIcon from "@mui/icons-material/Check";

const OfferBanner = ({ data }) => {
  if (!data || !data.title) {
    return null;
  }

  const { title, description, badgeText } = data;

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "stretch", md: "center" }}
      sx={{
        bgcolor: "#F3F8F5",
        border: "1px solid #CCE3D8",
        borderRadius: "12px",
        px: { xs: 1.5, md: 3 },
        py: { xs: 1.5, md: 2.5 },
        gap: { xs: 1.5, md: 2.25 },
        mb: 2,
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        spacing={1.5}
        sx={{ flex: 1, minWidth: 0 }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            minWidth: 32,
            borderRadius: "16px",
            bgcolor: "#086937",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckIcon sx={{ fontSize: 14, color: "#fff" }} />
        </Box>
        <Stack spacing={0.5} sx={{ minWidth: 0 }}>
          <Text
            sx={{
              fontWeight: 700,
              fontSize: { xs: 14, md: 18 },
              lineHeight: { xs: "20px", md: "24px" },
              color: "#086937",
            }}
          >
            {title}
          </Text>
          {description ? (
            <Text
              sx={{
                fontWeight: 500,
                fontSize: { xs: 12, md: 14 },
                lineHeight: { xs: "16px", md: "20px" },
                color: "#3D4942",
              }}
            >
              {description}
            </Text>
          ) : null}
        </Stack>
      </Stack>
      {badgeText ? (
        <Box
          sx={{
            bgcolor: "#E4F1EB",
            border: "1px solid #CCE3D8",
            borderRadius: "8px",
            px: { xs: 1.5, md: 2 },
            py: { xs: 1, md: 1.25 },
            alignSelf: { xs: "flex-start", md: "center" },
            flexShrink: 0,
          }}
        >
          <Text
            sx={{
              fontWeight: 600,
              fontSize: { xs: 12, md: 14 },
              lineHeight: { xs: "16px", md: "18px" },
              color: "#086937",
            }}
          >
            {badgeText}
          </Text>
        </Box>
      ) : null}
    </Stack>
  );
};

export default OfferBanner;
